import React, { useState } from "react";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import adminAction from "../../redux/admin/action";
import { useDispatch } from "react-redux";
import api from "../../api";
import { notify } from "../../utils/toast";
import logo from "../../assets/images/logo.png";
import "./login.css";

export const AdminLogin = ({ setAuthType }) => {
  const { setAdmin } = adminAction;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPass, setShowPass] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });

  const onTextChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const validators = () => {
    if (!data.email) return "Email is required";
    if (!data.password) return "Password is required";
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      const err = validators();
      if (err) throw new Error(err);
      const res = await api.adminLogin({ email: data.email, password: data.password });
      axios.defaults.headers.common["Authorization"] = res.token;
      localStorage.setItem("admintoken", res.token);
      setAuthType("admin");
      dispatch(setAdmin(res));
      navigate("/admin/dashboard");
    } catch (e) {
      notify.error(e.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="admin-login-page">
      {/* Left Panel */}
      <div className="admin-login-left">
        <div className="admin-login-decor1" />
        <div className="admin-login-decor2" />
        <div className="admin-login-decor3" />
        <div className="admin-login-logo-wrap">
          <img src={logo} alt="Shabbir Transport" className="admin-login-logo-img" />
        </div>
        <div className="admin-login-brand-name">Shabbir Transport</div>
        <div className="admin-login-brand-tagline">
          Reliable student transportation management for schools and institutes
        </div>
      </div>

      {/* Right Panel */}
      <div className="admin-login-right">
        <div className="admin-login-form-card">
          <div className="admin-login-form-title">Admin Portal</div>
          <div className="admin-login-form-subtitle">Sign in to manage your transport system</div>

          <form noValidate onSubmit={handleSubmit}>
            <div className="admin-login-field-group">
              <label className="admin-login-label">Email Address</label>
              <div className="admin-login-input-wrap">
                <span className="admin-login-input-icon">
                  <i className="fa-solid fa-envelope" />
                </span>
                <input
                  type="email"
                  name="email"
                  placeholder="admin@shabbirtransport.com"
                  className="admin-login-input"
                  onChange={onTextChange}
                />
              </div>
            </div>

            <div className="admin-login-field-group">
              <label className="admin-login-label">Password</label>
              <div className="admin-login-input-wrap">
                <span className="admin-login-input-icon">
                  <i className="fa-solid fa-lock" />
                </span>
                <input
                  type={showPass ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  className="admin-login-input"
                  onChange={onTextChange}
                />
                <button
                  type="button"
                  className="admin-login-eye-btn"
                  onClick={() => setShowPass(!showPass)}
                >
                  <i className={`fa-solid ${showPass ? "fa-eye-slash" : "fa-eye"}`} />
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="admin-login-submit-btn"
              style={{ opacity: loader ? 0.7 : 1 }}
              disabled={loader}
              onClick={handleSubmit}
            >
              {loader ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <a href="/" className="admin-login-back-link">← Back to website</a>
        </div>
      </div>
    </div>
  );
};
